import * as z from "zod";

export const disconnectGorgiasIntegration = {
  name: "disconnectGorgiasIntegration" as const,
  input: z.object({}),
  output: z.object({ success: z.boolean() }),
};
